@if ((batch$ | async)?.productionLine; as productionLine) {
  <div class="flex-none layout-row gap-sm p-sm">
    @for (segment of productionLine.segments; track segment) {
      <div
        class="layout-row place-start-center gap-xs segment"
        [matTooltip]="getToolTipTranslation(segment) | translate"
      >
        <mat-icon>{{ segmentIcon(segment) }}</mat-icon>
        <span class="mat-caption">{{ segment?.workCenterNumber }}</span>
      </div>
    }
  </div>
}
